/**
 * Input Component
 * Reusable form input with validation support
 */

import React, { forwardRef } from 'react';

const Input = forwardRef(({
  label,
  type = 'text',
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled = false,
  required = false,
  icon,
  className = '',
  ...props
}, ref) => {
  return (
    <div className={`lh-input-wrapper ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className="lh-input__label block text-sm font-medium text-dark-700 mb-1.5"
        >
          {label}
          {required && <span className="lh-input__required text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="lh-input__container relative">
        {icon && (
          <div className="lh-input__icon absolute left-3 top-1/2 -translate-y-1/2 text-dark-400">
            {icon}
          </div>
        )}
        <input
          ref={ref}
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          required={required}
          className={`
            lh-input__field w-full px-4 py-3 border rounded-lg outline-none transition-all duration-200
            ${icon ? 'lh-input__field--with-icon pl-10' : ''}
            ${error
              ? 'lh-input__field--error border-red-500 focus:ring-2 focus:ring-red-200'
              : 'lh-input__field--default border-dark-200 focus:border-primary-500 focus:ring-2 focus:ring-primary-100'
            }
            ${disabled ? 'lh-input__field--disabled bg-dark-50 cursor-not-allowed' : 'bg-white'}
          `}
          {...props}
        />
      </div>
      {(error || helperText) && (
        <p className={`lh-input__message text-sm mt-1 ${error ? 'lh-input__message--error text-red-500' : 'lh-input__message--helper text-dark-500'}`}>
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = 'Input';

export default Input;
